import {adPlatform} from "./platformSelector";
import {enableInterstitialAds} from "./interstitialTiming";

adPlatform.enableInterstitialAds = enableInterstitialAds;

export default adPlatform